<template lang="">
  <div class="mapBox" :isShowStatistic="isShowStatistic" :targetData="targetData">
    <fieldProperties v-if="fieldModel.fields.length>0" :fieldModel="fieldModel" :pos="fieldModelPos" @selectField="selectFieldEvent"/>

    <!-- 地图容器 -->
    <div id="map"></div>
    <fieldStatistic v-if="isShowStatistic" :statistic="statistic"/>
  </div>
</template>
<script>
import fieldStatistic from "../../components/fieldStatistic.vue";
import fieldProperties from "../../components/fieldProperties.vue";
import {
  AllUserFieldList,
  queryByPos,
  getFileByFileId,
  queryFieldsByFileIds,
  statisticFieldByUserId,
} from "../../api/fieldMG";
export default {
  name: "LeafletMap",
  props: {
    isShowStatistic: {
      default: true,
    },
    targetData: [],
  },
  data() {
    return {
      map: null,
      // 需要渲染到地图上的数据
      statistic: {
        all: {
          count: 0,
          area: 0,
        },
        boundary: {
          count: 0,
          area: 0,
        },
        obstacle: {
          count: 0,
          area: 0,
        },
        nospray: {
          count: 0,
          area: 0,
        },
      },
      fieldModel: {
        fileName: "",
        createTime: "",
        fieldCount: 0,
        totalArea: 0,
        selectField: {
          name: "",
          type: "",
          createTime: "",
          description: "",
        },
        fields: [],
      },
      fieldModelPos: {
        x: 200,
        y: 300,
      },
      // 地图上被选中的目标要素
      target: null,
    };
  },
  created() { },
  components: {
    fieldStatistic,
    fieldProperties,
  },
  mounted() {
    // 地图初始化
    this.initMap();
    if (null == this.targetData || this.targetData.length == 0) {
      // 初始化所有地块信息
      this.getAllData({ userId: localStorage.userId });
      this.statisticFunc({ userId: localStorage.userId });
    } else {
      // 初始化所有地块信息
      this.getDataByFileIds(this.targetData);
    }
  },
  methods: {
    // 使用id为map的div容器初始化地图，同时指定地图的中心点和缩放级别
    initMap() {
      let map = L.map("map", {
        center: [24.485666, 118.095498], // 中心位置
        minZoom: 3,
        maxZoom: 21,
        zoom: 12, // 缩放等级
        zoomControl: false,
        attributionControl: false, // 版权控件
      });

      this.map = map; // data上需要挂载

      // 加载底图
      var googleLayer = L.tileLayer(
        "http://mt2.google.com/vt/lyrs=s&hl=en&g0=hk&x={x}&y={y}&z={z}"
        // "https://mt1.google.com/vt/lyrs=r&x={x}&y={y}&z={z}"
      );
      googleLayer.options.maxNativeZoom = 18;
      googleLayer.options.maxZoom = 21;
      this.addLayerToMap(googleLayer, "google");

      var layer0 = L.tileLayer(
        "https://api.mapbox.com/v4/mapbox.satellite/{z}/{x}/{y}@2x.jpg90?access_token=sk.eyJ1IjoiZmllbGRtYW5hZ2UiLCJhIjoiY2t6eHk4ODZ2MDFmczJucXBibDBkYzlzNSJ9.t9O8-oz2-OpDrBLIOd2KUw"
      );
      layer0.options.maxNativeZoom = 18;
      layer0.options.maxZoom = 21;
      this.addLayerToMap(layer0, "mapbox");

      var osmLayer = L.tileLayer(
        "https://tile.openstreetmap.org/{z}/{x}/{y}.png"
      );
      osmLayer.options.maxNativeZoom = 18;
      osmLayer.options.maxZoom = 21;
      this.addLayerToMap(osmLayer, "OSM");

      // var layerTerrain = L.tileLayer(
      //   "http://stamen-tiles-a.a.ssl.fastly.net/terrain/{z}/{x}/{y}.png"
      // );
      // this.addLayerToMap(layerTerrain, "Terrian");

      L.control
        .scale({
          maxWidth: 200,
          metric: true,
          imperial: false,
        })
        .addTo(map);

      L.control
        .zoom({
          position: "topright",
          zoomInTitle: "zoom in",
          zoomOutTitle: "zoom out",
        })
        .addTo(map);

      L.easyButton(
        '<span class="iconfont icon-diqiu">',
        function (btn, map) {
          map.fitBounds(map.fieldLayer.getBounds());
        },
        "zoom to all"
      )
        .setPosition("topright")
        .addTo(map);
      L.control.locate({ position: "topright" }).addTo(map);

      // let message = this.$message;
      // // 编辑多边形
      // L.easyButton(
      //   '<span class="iconfont icon-dianxuanquyu">',
      //   function (btn, map) {
      //     message.warning("to do");
      //   },
      //   "edit field"
      // )
      //   .setPosition("topright")
      //   .addTo(map);

      L.Control.FileLayerLoad.LABEL = '<span class="el-icon-folder-opened"/>';
      L.Control.fileLayerLoad({
        position: "topright",
        // Allows you to use a customized version of L.geoJson.
        // For example if you are using the Proj4Leaflet leaflet plugin,
        // you can pass L.Proj.geoJson and load the files into the
        // L.Proj.GeoJson instead of the L.geoJson.
        layer: L.geoJson,
        // See http://leafletjs.com/reference.html#geojson-options
        layerOptions: { style: { color: "red" } },
        // Add to map after loading (default: true) ?
        addToMap: true,
        // File size limit in kb (default: 1024) ?
        fileSizeLimit: 20480,
        // Restrict accepted file formats (default: .geojson, .json, .kml, and .gpx) ?
        formats: [".geojson", ".kml"],
      }).addTo(map);

      L.control.measure().addTo(map);
    },

    // 添加图层
    addLayerToMap(layer, name) {
      // var tempLayer = layer.addTo(this.map);
      var tempLayer = layer;
      tempLayer.isVisiable = true;
      if (this.map.layers == null) {
        this.map.layers = new Array();
        layer.addTo(this.map);
      }
      this.map.layers[name] = tempLayer;
      if (this.map.groupLayer != null) {
        this.map.groupLayer.remove();
      }
      this.map.groupLayer = L.control
        .layers(this.map.layers, null, { position: "bottomright" })
        .addTo(this.map);
    },

    // 移除图层
    removeLayerFromMap(name) {
      var layer = this.map.layers[name];
      layer.removeFrom(this.map);
      layer.isVisiable = false;
    },

    // 将field转换成可添加到图层的要素
    field2Fea(field) {
      if (null != field.geom) {
        let fea = {
          type: "Feature",
          geometry: JSON.parse(field.geom),
          properties: {
            type: field.type,
            fieldId: field.fieldId,
            fileId: field.fileId,
          },
        };
        return fea;
      }
      return null;
    },

    getFeaStyle(feature) {
      switch (feature.properties.type) {
        case "boundary":
          return { color: "#76B73D", weight: 2, fillOpacity: 0.2 };
        case "nospray":
          return { color: "#E48000", weight: 2, fillOpacity: 0.2 };
        case "obstacle":
          return { color: "#DA0000", weight: 2, fillOpacity: 0.2 };
      }
    },

    // 显示目标地块
    showFields(fieldList) {
      if (fieldList.length == 0) {
        this.map.fitWorld();
        return;
      }
      let tempField = fieldList[0];
      let fea = this.field2Fea(tempField);
      fieldList.shift();
      var layer = L.geoJson(fea).addTo(this.map);

      this.map.fieldLayer = layer;
      fieldList.forEach((field) => {
        fea = this.field2Fea(field);
        if (fea.geometry != null) {
          layer.addData(fea);
        }
      });
      let getFeaStyle = this.getFeaStyle;
      layer.setStyle(function (feature) {
        return getFeaStyle(feature);
      });
      this.map.fitBounds(layer.getBounds());
      this.showFieldMessage(layer);

      let fieldModel = this.fieldModel;
      this.map.on("mousedown", function (ev) {
        fieldModel.fields = [];
      });
    },

    // 获取该用户的所有地块
    getAllData(params) {
      AllUserFieldList(params).then((res) => {
        if (res.status == 200) {
          var fieldList = res.result;
          this.showFields(fieldList);
        } else {
          this.$message.error(res.message);
        }
      });
    },

    getDataByFileIds(fileIdList) {
      queryFieldsByFileIds(fileIdList).then((res) => {
        if (res.status == 200) {
          var fieldList = res.result;
          this.showFields(fieldList);
        } else {
          this.$message.error(res.message);
        }
      });
    },

    // 统计信息
    statisticFunc(params) {
      statisticFieldByUserId(params).then((res) => {
        if (res.status != 200) {
          this.$message.error("field statistic error!");
          retrun;
        }
        res = res.result;
        this.statistic.all.count = res.all.count;
        this.statistic.all.area = (res.all.area / 1.0e4).toFixed(2) + " ha";
        this.statistic.boundary.count = res.boundary.count;
        this.statistic.boundary.area =
          (res.boundary.area / 1.0e4).toFixed(2) + " ha";
        this.statistic.nospray.count = res.nospray.count;
        this.statistic.nospray.area =
          (res.nospray.area / 1.0e4).toFixed(2) + " ha";
        this.statistic.obstacle.count = res.obstacle.count;
        this.statistic.obstacle.area =
          (res.obstacle.area / 1.0e4).toFixed(2) + " ha";
      });
    },

    // 高亮目标
    highlightFea(fea) {
      if (this.target != null) {
        this.target.setStyle(this.getFeaStyle(this.target.feature));
      }
      fea.setStyle({
        color: "#ffff00",
      });
      this.target = fea;
    },

    // 显示地块信息
    showFieldMessage(layer) {
      let map = this.map;
      let fieldModel = this.fieldModel;
      let fieldModelPos = this.fieldModelPos;
      let highlightFea = this.highlightFea;
      layer.on("click", function (evt) {
        fieldModelPos.x = evt.containerPoint.x;
        fieldModelPos.y = evt.containerPoint.y;
        highlightFea(evt.sourceTarget);
        let properties = evt.layer.feature.properties;
        getFileByFileId({ fileId: properties.fileId }).then((fileRes) => {
          fileRes = fileRes.result;
          fieldModel.fileName = fileRes.fileName;
          fieldModel.createTime = fileRes.createTime;
        });

        queryFieldsByFileIds([properties.fileId]).then((res) => {
          res = res.result;
          fieldModel.fieldCount = res.length;
          fieldModel.totalArea = (
            res.map(p => p.area).reduce((a, b) => a.area + b.area) / 10000.0
          ).toFixed(2);
          fieldModel.selectField = res.find(
            (p) => p.fieldId == properties.fieldId
          );
          fieldModel.fields = res;
        });
      });
    },

    // 地块信息中选择的地块
    selectFieldEvent(field) {
      let layer = this.map.fieldLayer;
      for (var key in layer._layers) {
        if (layer._layers[key].feature.properties.fieldId == field.fieldId) {
          let fea = layer._layers[key];
          this.highlightFea(fea);
          return;
        }
      }
    },
  },
};
</script>
<style scoped>
.mapBox {
  margin: 0%;
  padding: 3px auto;
}

#map {
  width: 100%;
  /* height: 875px; */
  height: calc(100vh - 64px);
  z-index: 1;
}

.leaflet-control-locate.active a .leaflet-control-locate-location-arrow {
  background-color: rgb(50, 50, 50);
}

.leaflet-right .leaflet-control {
  margin-right: 20px;
  margin-top: 10px;
}

.leaflet-control-measure a.start {
  display: inline;
  width: auto;
  height: auto;
  padding-left: 20px;
  margin-right: 4px;
  line-height: 1em;
  border: 0;
  text-align: left;
  /* background-image: url(assets/start.png); */
  background-repeat: no-repeat;
  background-position: 0 50%;
  background-size: 12px 12px;
  color: #5e66cc;
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/views/map/map.vue